import { render, staticRenderFns } from "./SocialLoginRegistrationModal.vue?vue&type=template&id=245adf18&scoped=true"
import script from "./SocialLoginRegistrationModal.vue?vue&type=script&lang=js"
export * from "./SocialLoginRegistrationModal.vue?vue&type=script&lang=js"
import style0 from "./SocialLoginRegistrationModal.vue?vue&type=style&index=0&id=245adf18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245adf18",
  null
  
)

export default component.exports